module.exports = __webpack_public_path__ + "img/green_use_of_land_color.c7637a69.svg";